import React from "react";
import PropTypes from "prop-types";
import StoreLightingControlPanelItem from "./StoreLightingControlPanelItem";
import { GridItem } from "@sainsburys-tech/fable";

const StoreLightingControlPanel = props => {
  return (
    <GridItem colSpan={{ xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}>
      <StoreLightingControlPanelItem
        storeStatus={props.storeStatus}
        usage={props.code}
        storeId={props.storeId}
      />
    </GridItem>
  );
};

StoreLightingControlPanel.propTypes = {
  storeStatus: PropTypes.shape({
    commissioningStatus: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string
    }),
    gatewayOnline: PropTypes.boolean
  }),
  controlPanels: PropTypes.string,
  storeId: PropTypes.string.isRequired
};

export default StoreLightingControlPanel;
